import { getAccessTokenSilently, getLocalStorageItem } from "utils/functions";
import { uploadFile } from "pages/auth/Presigned";
import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import PaymentIcon from "@material-ui/icons/Payment";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import DefaultUserOPNG from "assets/icons/default-user.png";
import ContactsOutlinedIcon from "@material-ui/icons/ContactsOutlined";
import { SubHeader } from "layout/SubHeader";
import AuthService from "Lib/API/Auth";
import React, { useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import { DirectorySetting } from "./DirectorySetting";
import PersonalInfoEdit from "./editInfo";
import "./index.scss";
import PaymentMethods from "./paymentMethod";
import { Fonts, FontColors } from "theme/fontConfig";

const tabsList = {
  personalInformation: 0,
  paymentMethods: 1,
  directory: 2,
};

const SettingsPage = () => {
  const { search, pathname } = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(search);
  const tabParams = searchParams.get("tab");
  const activePaymentParams = searchParams.get("activePayment");
  const isMobile = useMediaQuery("(max-width:600px)");

  const [selected, setSelected] = useState(tabParams ? tabsList[tabParams] : 0);
  const user = getLocalStorageItem("accountInfo", true);
  const memberPortalDirectoryPermission = JSON.parse(
    localStorage.getItem("memberPortalDirectory")
  );

  const [userInfo, setUserInfo] = useState();
  const [profileImgSrc, setProfileImgSrc] = useState(null);
  const fileInputRef = useRef(null);

  const handleProfileImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // Show local preview immediately
    const reader = new FileReader();
    reader.onload = (ev) => setProfileImgSrc(ev.target.result);
    reader.readAsDataURL(file);
    try {
      const token = await getAccessTokenSilently();
      const newUrl = await uploadFile(file, file, token);
      if (newUrl?.fileName) {
        await AuthService.updateAccountSetting(
          { profile_img: newUrl.fileName, contactID: userInfo?.user?.permissions?.linked_contact?._id },
          token
        );
        toastr.success("Success", "Profile picture updated");
      }
    } catch (err) {
      toastr.error("Error", err?.data?.message || "Failed to update profile picture");
      setProfileImgSrc(null);
    }
  };

  const resetSearchParams = () => {
    history.push({
      pathname,
      search: "",
    });
  };

  React.useEffect(() => {
    if (tabParams) {
      setSelected(tabsList[tabParams]);
      resetSearchParams();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabParams]);

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      AuthService.getUserExist(token)
        .then((res) => {
          localStorage.setItem(
            "organization",
            JSON.stringify(res?.user?.permissions?.organization)
          );
          localStorage.setItem(
            "linkedAccount",
            JSON.stringify(res?.user?.permissions?.linked_account)
          );
          console.log(res, "res");
          setUserInfo(res);
        })
        .catch((err) => {
          setUserInfo(err);
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAccessTokenSilently]);

  const tabs = [
    { label: "Personal Info", icon: <AccountCircleIcon fontSize="small" />, index: 0 },
    { label: "Payment Methods", icon: <PaymentIcon fontSize="small" />, index: 1 },
    ...(memberPortalDirectoryPermission
      ? [{ label: "Directory", icon: <ContactsOutlinedIcon fontSize="small" />, index: 2 }]
      : []),
  ];

  return (
    <>
      <div className="m-0 w-100">
        <div className="settings-container">
          {isMobile ? (
            <>
              {/* Mobile tab bar */}
              <div style={{ display: "flex", gap: 8, marginTop: 12, marginBottom: 8, overflowX: "auto" }}>
                {tabs.map((tab) => (
                  <button
                    key={tab.index}
                    onClick={() => setSelected(tab.index)}
                    style={{
                      display: "flex", alignItems: "center", gap: 6,
                      padding: "8px 14px", borderRadius: 8, border: "none",
                      background: selected === tab.index ? "#2555EF" : "#F1F5F9",
                      color: selected === tab.index ? "#fff" : "#475569",
                      ...Fonts.GeneralButtonFont, 
                      cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0,
                    }}
                  >
                    {tab.icon}
                    {tab.label}
                  </button>
                ))}
              </div>
              {/* Mobile content */}
              <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", padding: 16 }}>
                {selected === 0 ? (
                  <PersonalInfoEdit userInfo={userInfo} userId={userInfo?.user?._id} />
                ) : selected === 1 ? (
                  <PaymentMethods activePaymentParams={activePaymentParams} />
                ) : (
                  <DirectorySetting />
                )}
              </div>
            </>
          ) : (
            <Grid container xs={12} className="">
              <Grid item xs={12} md={6} className="profile-data">
                <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", padding: 16, marginTop: 16 }}>
                  <div className="profile-container">
                    <div className="user-info">
                      <div
                        className="profile-img-wrapper"
                        onClick={() => fileInputRef.current?.click()}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { if (fileInputRef.current) fileInputRef.current.click(); } }}
                        role="button"
                        tabIndex={0}
                        aria-label="Change profile picture"
                        style={{ position: "relative", display: "inline-block", cursor: "pointer" }}
                      >
                        <img
                          alt="Profile picture"
                          src={profileImgSrc || userInfo?.user?.permissions?.linked_contact?.profile_img || DefaultUserOPNG}
                          style={{ objectFit: "cover", display: "block" }}
                          height="102"
                          width="99"
                          className="with-border rounded"
                        />
                        <div className="profile-img-overlay" aria-hidden="true">
                          <CameraAltIcon style={{ color: FontColors.White, fontSize: 26 }} />
                        </div>
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/*"
                          aria-label="Upload profile picture"
                          style={{ display: "none" }}
                          onChange={handleProfileImageChange}
                        />
                      </div>
                      <div className="user">
                        <div className="user-name">{user?.nickname}</div>
                        <div className="user-email">{user?.primary_email_address}</div>
                      </div>
                    </div>
                    <nav className="personal-information" aria-label="Settings navigation">
                      <div>
                        <div
                          className={selected === 0 ? "active container" : "container"}
                          onClick={() => setSelected(0)}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setSelected(0); }}
                          role="button"
                          tabIndex={0}
                          aria-current={selected === 0 ? "page" : undefined}
                        >
                          <AccountCircleIcon fontSize="large" className="mx-10" aria-hidden="true" />
                          Personal Information
                        </div>
                      </div>
                      <div>
                        <div
                          className={selected === 1 ? "active container" : "container"}
                          onClick={() => setSelected(1)}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setSelected(1); }}
                          role="button"
                          tabIndex={0}
                          aria-current={selected === 1 ? "page" : undefined}
                        >
                          <PaymentIcon fontSize="large" className="mx-10" aria-hidden="true" />
                          Payment Methods
                        </div>
                      </div>
                      {memberPortalDirectoryPermission && (
                        <div>
                          <div
                            className={selected === 2 ? "active container" : "container"}
                            onClick={() => setSelected(2)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setSelected(2); }}
                            role="button"
                            tabIndex={0}
                            aria-current={selected === 2 ? "page" : undefined}
                          >
                            <ContactsOutlinedIcon fontSize="large" className="mx-10" aria-hidden="true" />
                            Directory
                          </div>
                        </div>
                      )}
                    </nav>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={6} className="profile-information">
                <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", padding: 16, marginTop: 16 }}>
                  {selected === 0 ? (
                    <PersonalInfoEdit userInfo={userInfo} userId={userInfo?.user?._id} />
                  ) : selected === 1 ? (
                    <PaymentMethods activePaymentParams={activePaymentParams} />
                  ) : (
                    <DirectorySetting />
                  )}
                </div>
              </Grid>
            </Grid>
          )}
        </div>
      </div>
    </>
  );
};
export default SettingsPage;
